module.exports = __webpack_public_path__ + "img/logo_BIDV.ef5ea937.svg";